import { render, staticRenderFns } from "./linkingLogin.vue?vue&type=template&id=32502ca7&scoped=true"
import script from "./linkingLogin.vue?vue&type=script&lang=js"
export * from "./linkingLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32502ca7",
  null
  
)

export default component.exports